"use client";

import { useTranslations } from "next-intl";

/**
 * Renders the names of week days for the calendar component mon, tue, ...
 * არენდერებს კალენდარის კომპონენტის კვირის დღეების სახელებს ორშ, სამ, ...
 *
 * @component
 * @param {DayNamesProps} props - The component props.
 * @param {string[]} props.daysOfWeek - The array of day names.
 * @returns {JSX.Element} The rendered component.
 */

export const DayNames = ({ daysOfWeek }: { daysOfWeek: string[] }) => {
  const g = useTranslations("General");

  return (
    <div className="mb-0 grid grid-cols-7 gap-2 md:mb-4">
      {daysOfWeek.map((day, index) => (
        <div key={index} className="text-center">
          {g(day)}
        </div>
      ))}
    </div>
  );
};
